import type { ComponentProps } from "react";
import { useParams } from "react-router";
import { ArrowLeft } from "lucide-react";
import { AdminDataNotice } from "@/components/admin/data-notice";
import { ClientDetail } from "@/components/admin/client-detail";
import { Link } from "@shared/client/navigation";
import { usePageTitle, useView } from "@shared/client/view";
import { AdminChip, AdminMeta } from "@shared/components/blocks";
import { Button } from "@shared/components/ui/button";

const CLIENT_STATUS_LABELS: Record<string, string> = {
  lead: "Prospect",
  trial: "Essai",
  active: "Actif",
  churned: "Perdu",
};

type ClientData = ComponentProps<typeof ClientDetail>;

export default function AdminClientPage() {
  usePageTitle("Fiche client — Administration Hune");
  const { id = "" } = useParams();
  const { data, error: loadError } = useView<ClientData>(`/api/views/admin/clients/${encodeURIComponent(id)}`);

  if (loadError) {
    return (
      <>
        <AdminMeta>
          <Button asChild className="h-auto px-0 text-muted-foreground" size="sm" variant="link">
            <Link href="/admin/clients"><ArrowLeft className="size-3.5" /> Tous les clients</Link>
          </Button>
        </AdminMeta>
        <AdminDataNotice error={loadError} />
      </>
    );
  }
  if (!data) return null;
  const { client, plans, agentCosts } = data;

  return (
    <>
      <AdminMeta note={client.website}>
        <span className="flex flex-wrap items-center gap-2.5">
          <Button asChild className="h-auto px-0 text-muted-foreground" size="sm" variant="link">
            <Link href="/admin/clients"><ArrowLeft className="size-3.5" /> Tous les clients</Link>
          </Button>
          <strong className="text-[13.5px] font-semibold text-foreground">{client.name}</strong>
          <AdminChip tone={client.status}>{CLIENT_STATUS_LABELS[client.status] ?? client.status}</AdminChip>
        </span>
      </AdminMeta>
      <ClientDetail agentCosts={agentCosts} client={client} plans={plans} />
    </>
  );
}
